export enum ReportStatus {
  Pending = 'pending',
  Completed = 'completed',
  Failed = 'failed',
}
